import * as React from 'react'
import { ColorSchemeToggle } from '@/components/Elements'
import { PublicHeader } from '@/components/Layouts/Elements'
import useStyles from './Header.styles'

interface IProps {
  lang?: boolean
  colorScheme?: boolean
}

export const Header = ({ lang = false, colorScheme = false }: IProps) => {
  const { classes } = useStyles()

  return <PublicHeader rightSection={colorScheme ? <ColorSchemeToggle /> : undefined} />
}
